import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Box,
} from "@material-ui/core";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const FinalizacaoVendaModal = ({ open, onClose, ticket, onFinalizar }) => {
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [vendaConcluida, setVendaConcluida] = useState(true);
  const [valorVenda, setValorVenda] = useState("");
  const [motivoNaoVenda, setMotivoNaoVenda] = useState("");
  const [motivoNaoVendaOutro, setMotivoNaoVendaOutro] = useState("");
  const [criarFollowUp, setCriarFollowUp] = useState(true);
  const [followUpDate, setFollowUpDate] = useState("");
  const [followUpMessage, setFollowUpMessage] = useState("");
  const [motivosFinalizacao, setMotivosFinalizacao] = useState([]);
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [creatingRecoveryRule, setCreatingRecoveryRule] = useState(false);

  const resetForm = () => {
    setVendaConcluida(true);
    setValorVenda("");
    setMotivoNaoVenda("");
    setMotivoNaoVendaOutro("");
  };


  const getTomorrowDateTime = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(9, 0, 0, 0);

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");

    return `${y}-${m}-${d}T${h}:${min}`;
  };


  const normalizeSmartText = value =>
    String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const getSmartFollowUpConfig = motivo => {
    const normalized = normalizeSmartText(motivo);

    if (
      normalized.includes("preco") ||
      normalized.includes("caro") ||
      normalized.includes("valor") ||
      normalized.includes("orcamento")
    ) {
      return {
        days: 1,
        hour: 10,
        message:
          "Olá, tudo bem? Pensei melhor no seu caso e posso te mostrar uma condição mais acessível ou uma alternativa que encaixe melhor no seu orçamento. Posso te mandar?"
      };
    }

    if (
      normalized.includes("produto") ||
      normalized.includes("estoque") ||
      normalized.includes("indisponivel") ||
      normalized.includes("nao temos")
    ) {
      return {
        days: 2,
        hour: 9,
        message:
          "Olá, tudo bem? Estou passando para te avisar sobre a disponibilidade/opções parecidas com o que você procurou. Posso te mostrar uma alternativa?"
      };
    }

    if (
      normalized.includes("interesse") ||
      normalized.includes("nao quer") ||
      normalized.includes("sem interesse")
    ) {
      return {
        days: 3,
        hour: 10,
        message:
          "Olá, tudo bem? Entendo que talvez agora não seja o melhor momento. Posso te mostrar uma opção mais simples para você avaliar sem compromisso?"
      };
    }

    if (
      normalized.includes("pensar") ||
      normalized.includes("depois") ||
      normalized.includes("retornar") ||
      normalized.includes("analisar")
    ) {
      return {
        days: 1,
        hour: 14,
        message:
          "Olá, tudo bem? Passando para saber se você conseguiu analisar com calma. Posso te ajudar com alguma dúvida antes de você decidir?"
      };
    }

    return {
      days: 1,
      hour: 9,
      message:
        "Olá, tudo bem? Vi que você demonstrou interesse e quero te ajudar a encontrar a melhor opção. Posso te enviar uma sugestão personalizada?"
    };
  };

  const getSmartDateTime = motivo => {
    const config = getSmartFollowUpConfig(motivo);
    const date = new Date();

    date.setDate(date.getDate() + config.days);
    date.setHours(config.hour, 0, 0, 0);

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");

    return `${y}-${m}-${d}T${h}:${min}`;
  };


  const getSmartRecoveryMessages = motivo => {
    const normalized = normalizeSmartText(motivo);

    if (
      normalized.includes("preco") ||
      normalized.includes("caro") ||
      normalized.includes("valor") ||
      normalized.includes("orcamento")
    ) {
      return [
        "Olá, tudo bem? Pensei melhor no seu caso e posso te mostrar uma condição mais acessível ou uma alternativa que encaixe melhor no seu orçamento. Posso te mandar?",
        "Oi, passando só para saber se ainda faz sentido eu te mostrar uma opção com melhor custo-benefício para o que você precisa.",
        "Passando para encerrar meu acompanhamento por aqui. Consegui uma alternativa melhor para você avaliar sem compromisso."
      ];
    }

    if (
      normalized.includes("produto") ||
      normalized.includes("estoque") ||
      normalized.includes("indisponivel") ||
      normalized.includes("nao temos")
    ) {
      return [
        "Olá, tudo bem? Estou passando para te mostrar uma alternativa parecida com o que você procurou. Posso te mandar?",
        "Oi, encontrei uma possibilidade que pode atender o que você precisava. Quer que eu te mostre?",
        "Passando para encerrar meu acompanhamento por aqui. Se ainda fizer sentido, posso te ajudar a encontrar uma opção mais próxima do que você procura."
      ];
    }

    if (
      normalized.includes("interesse") ||
      normalized.includes("nao quer") ||
      normalized.includes("sem interesse")
    ) {
      return [
        "Olá, tudo bem? Entendo que talvez agora não seja o melhor momento. Posso te mostrar uma opção mais simples para você avaliar sem compromisso?",
        "Oi, tudo bem? Separei uma opção que pode encaixar melhor no que você procura. Posso te mostrar?",
        "Passando para encerrar meu acompanhamento por aqui. Quando quiser retomar, posso te ajudar com uma opção mais adequada."
      ];
    }

    if (
      normalized.includes("pensar") ||
      normalized.includes("depois") ||
      normalized.includes("retornar") ||
      normalized.includes("analisar")
    ) {
      return [
        "Olá, tudo bem? Passando para saber se você conseguiu analisar com calma. Posso te ajudar com alguma dúvida antes de você decidir?",
        "Oi, tudo bem? Só retomando nosso contato. Ficou alguma dúvida sobre a opção que conversamos?",
        "Passando para encerrar meu acompanhamento por aqui. Posso te ajudar com uma última condição para facilitar sua decisão?"
      ];
    }

    return [
      "Olá, tudo bem? Vi que você demonstrou interesse e quero te ajudar a encontrar a melhor opção. Posso te enviar uma sugestão personalizada?",
      "Oi, tudo bem? Tenho uma alternativa que pode ser mais adequada para o que você estava buscando. Quer que eu te mostre?",
      "Passando para encerrar meu acompanhamento por aqui. Se ainda fizer sentido para você, posso te ajudar com uma última opção."
    ];
  };

  const formatDateTimeLocal = date => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");

    return `${y}-${m}-${d}T${h}:${min}`;
  };

  const getContactId = () => {
    return ticket?.contactId || ticket?.contact?.id || ticket?.Contact?.id || null;
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  useEffect(() => {
    if (open) {
      fetchMotivosFinalizacao();
      if (open) {
    setCriarFollowUp(true);
    setFollowUpDate(getTomorrowDateTime());
    setFollowUpMessage(getSmartFollowUpConfig("").message);
  }
}
  }, [open]);

  const fetchMotivosFinalizacao = async () => {
    try {
      setLoadingConfig(true);
      const { data } = await api.get("/ticketFinalizationReasons");
      setMotivosFinalizacao(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Erro ao buscar motivos de finalização:", err);
      setMotivosFinalizacao([]);
    } finally {
      setLoadingConfig(false);
    }
  };

  const parseMoney = value => {
    if (!value) return 0;

    const normalized = String(value)
      .replace(/\./g, "")
      .replace(",", ".")
      .replace(/[^\d.]/g, "");

    return Number(normalized || 0);
  };


  useEffect(() => {
    if (!open || vendaConcluida) return;

    const motivoAtual =
      motivoNaoVenda === "__outro__" ? motivoNaoVendaOutro : motivoNaoVenda;

    const config = getSmartFollowUpConfig(motivoAtual);

    if (
      !followUpMessage ||
      followUpMessage.includes("Retomar contato") ||
      followUpMessage.includes("recuperar a venda") ||
      followUpMessage.includes("Estou retomando nossa conversa")
    ) {
      setFollowUpMessage(config.message);
    }

    if (!followUpDate) {
      setFollowUpDate(getSmartDateTime(motivoAtual));
    }
  }, [open, vendaConcluida, motivoNaoVenda, motivoNaoVendaOutro]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const valorNumerico = parseMoney(valorVenda);

      if (vendaConcluida && valorNumerico <= 0) {
        toast.error("Informe o valor da venda para finalizar como venda realizada.");
        return;
      }

      if (!vendaConcluida) {
        const motivoFinal = motivoNaoVenda === "__outro__" ? motivoNaoVendaOutro : motivoNaoVenda;

        if (!motivoFinal || !motivoFinal.trim()) {
          toast.error("Informe o motivo da não venda.");
          return;
        }
      }

      const motivoFinal = motivoNaoVenda === "__outro__" ? motivoNaoVendaOutro : motivoNaoVenda;

      const ticketData = {
        status: "closed",
        userId: user?.id || null,
        finalizadoComVenda: vendaConcluida,
        valorVenda: vendaConcluida ? valorNumerico : null,
        motivoNaoVenda: vendaConcluida ? null : motivoFinal,
        motivoFinalizacao: vendaConcluida ? "Venda realizada" : motivoFinal,
      };

      if (onFinalizar) {
    if (!vendaConcluida && criarFollowUp && followUpDate && !creatingRecoveryRule) {
      setCreatingRecoveryRule(true);

      const contactId = getContactId();
      const ticketId = ticket?.id;

      if (!ticketId && !contactId) {
        alert("Não consegui identificar o contato/ticket para criar a régua automática. A finalização continuará normalmente.");
        setCreatingRecoveryRule(false);
      } else {
        try {
          const baseDate = new Date(followUpDate);
          const messages = getSmartRecoveryMessages(motivoFinal);

          const steps = [
            { number: 1, addDays: 0, message: followUpMessage || messages[0] },
            { number: 2, addDays: 2, message: messages[1] },
            { number: 3, addDays: 6, message: messages[2] }
          ];

          for (const step of steps) {
            const scheduleDate = new Date(baseDate);
            scheduleDate.setDate(scheduleDate.getDate() + step.addDays);

            const scheduleData = {
              body: `[Recuperação ${step.number}/3] ${step.message}`,
              sendAt: formatDateTimeLocal(scheduleDate),
              reminderDate: formatDateTimeLocal(scheduleDate),
              contactId: contactId || undefined,
              ticketId: ticketId || undefined,
              userId: ticket?.userId || undefined,
              ticketUserId: ticket?.userId || undefined,
              queueId: ticket?.queueId || undefined,
              whatsappId: ticket?.whatsappId || undefined,
              statusTicket: ticket?.status || "open"
            };

            console.log("Criando follow-up de recuperação:", scheduleData);

            await api.post("/schedules", scheduleData);
          }
        } catch (scheduleError) {
          console.error("Erro ao criar régua automática de recuperação:", scheduleError);
          alert("A finalização continuará, mas não foi possível criar a régua automática de follow-up. Verifique o console/logs.");
        } finally {
          setCreatingRecoveryRule(false);
        }
      }
    }

    await onFinalizar(ticketData);
      }

      resetForm();
    } catch (err) {
      console.error("Erro ao finalizar atendimento:", err);
      toast.error("Erro ao finalizar atendimento.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Finalização Comercial
      </DialogTitle>

      <DialogContent>
        <Box
          style={{
            background: "linear-gradient(135deg, #111827 0%, #b91c1c 55%, #ef4444 100%)",
            color: "#fff",
            padding: 16,
            borderRadius: 14,
            marginBottom: 18,
          }}
        >
          <Typography style={{ fontWeight: 800, fontSize: 18 }}>
            Este atendimento virou venda?
          </Typography>
          <Typography style={{ opacity: 0.9, marginTop: 4 }}>
            Essa informação alimenta o dashboard de conversão, ranking dos vendedores e ticket médio.
          </Typography>
        </Box>

        {loadingConfig ? (
          <Typography>Carregando motivos...</Typography>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Resultado do atendimento
                </FormLabel>

                <RadioGroup
                  value={vendaConcluida ? "true" : "false"}
                  onChange={e => setVendaConcluida(e.target.value === "true")}
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Sim, venda realizada"
                  />

                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="Não houve venda"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            {vendaConcluida ? (
              <Grid item xs={12}>
                <TextField
                  label="Valor da venda"
                  value={valorVenda}
                  onChange={e => setValorVenda(e.target.value)}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  placeholder="Ex: 1500,00"
                  helperText="Obrigatório para calcular valor vendido e ticket médio."
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" margin="dense" required>
                    <InputLabel>Motivo da não venda</InputLabel>
                    <Select
                      value={motivoNaoVenda}
                      onChange={e => setMotivoNaoVenda(e.target.value)}
                      label="Motivo da não venda"
                    >
                      <MenuItem value="">
                        <em>Selecione um motivo</em>
                      </MenuItem>

                      {motivosFinalizacao.map(motivo => (
                        <MenuItem key={motivo.id} value={motivo.name}>
                          {motivo.name}
                        </MenuItem>
                      ))}

                      <MenuItem value="__outro__">
                        Outro motivo
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {motivoNaoVenda === "__outro__" && (
                  <Grid item xs={12}>
                    <TextField
                      label="Descreva o motivo"
                      value={motivoNaoVendaOutro}
                      onChange={e => setMotivoNaoVendaOutro(e.target.value)}
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      multiline
                      rows={3}
                    />
                  </Grid>
                )}
              </>
            )}
          </Grid>
        )}
      </DialogContent>

      
        {!vendaConcluida && (
          <Grid item xs={12}>
            <div
              style={{
                border: "1px solid #fee2e2",
                borderRadius: 12,
                padding: 14,
                background: "#fff7f7",
                marginTop: 8
              }}
            >
              <div style={{ fontWeight: 800, color: "#991b1b", marginBottom: 8 }}>
                Régua automática de recuperação
              </div>

              <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                <input
                  type="checkbox"
                  checked={criarFollowUp}
                  onChange={e => setCriarFollowUp(e.target.checked)}
                />
                Criar sequência automática de 3 follow-ups para recuperar esta venda
              </label>

              {criarFollowUp && (
                <>
                  <TextField
                    label="Data e hora do próximo contato"
                    type="datetime-local"
                    variant="outlined"
                    fullWidth
                    value={followUpDate}
                    onChange={e => setFollowUpDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    style={{ marginBottom: 12 }}
                  />

                  <TextField
                    label="Mensagem do lembrete"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={2}
                    value={followUpMessage}
                    onChange={e => setFollowUpMessage(e.target.value)}
                    placeholder="Ex: Retomar contato amanhã para tentar recuperar a venda."
                  />
                </>
              )}
            </div>
          </Grid>
        )}


      <DialogActions>
        <Button onClick={handleClose} color="secondary" disabled={loading}>
          Cancelar
        </Button>

        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading || loadingConfig || creatingRecoveryRule}
          style={{
            background: "#b91c1c",
            color: "#fff",
            fontWeight: 800,
          }}
        >
          {creatingRecoveryRule ? "Criando régua..." : loading ? "Finalizando..." : "Continuar finalização"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FinalizacaoVendaModal;
